var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "custom-widget-node" }, [_c('div', { staticClass: "content" }, [_vm._v("\n    " + _vm._s(_vm.selectNode) + "\n    "), _c('el-button', { staticClass: "select-node", attrs: { "type": "primary" }, on: { "click": _vm.openSceneNodeDialog } }, [_vm._v("节点选择")])], 1), _vm._v(" "), _c('scene-node-dialog', { ref: "SceneNodeDialog", on: { "selectNode": _vm.selectNodeHandler } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };